import React from 'react';
import { Link } from 'react-router-dom';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import './ContactInfo.css';

const OFFICES = [
  {
    title: 'Head Office',
    lines: [
      '6th floor, Meydan Grandstand,',
      'Meydan Road, Nad Al Sheba,',
      'Dubai, U.A.E.',
    ],
    phone: '+971-50-3657140',
    email: 'info@innatetechnologies.net',
  },
  {
    title: 'India',
    lines: [
      'Kakkanad, Kochi,',
      'Kerala, India.',
    ],
    email: 'support@innatetechnologies.net',
  },
  {
    title: 'Qatar',
    lines: [
      'Building No. 355, Near Gate No.8',
      'Grand Mall, Asian Town,',
      'Doha, Qatar.',
    ],
    phone: '+974-66562784',
    email: 'info@innatetechnologies.net',
  },
];

const ContactInfo = () => {
  return (
    <div className="contact-info-container">
      <div className="info-header">
        {/* <h2>Alternatively:</h2> */}
        <p className="email-link">
          Email us to <Link to="mailto:info@flowdo.biz">info@flowdo.biz</Link>
        </p>
      </div>

      <div className="office-list">
        {OFFICES.map((office) => (
          <div key={office.title} className="office-card">
            <h3>{office.title}</h3>
            <p className="office-address">
              <FiMapPin aria-hidden="true" />
              <span>
                {office.lines.map((line) => (
                  <span key={line} className="office-address-line">
                    {line}
                  </span>
                ))}
              </span>
            </p>
            {office.phone ? (
              <p className="office-meta">
                <FiPhone aria-hidden="true" />
                <a href={`tel:${office.phone.replace(/\s/g, '')}`}>Tel: {office.phone}</a>
              </p>
            ) : null}
            {office.email ? (
              <p className="office-meta">
                <FiMail aria-hidden="true" />
                <a href={`mailto:${office.email}`}>Email: {office.email}</a>
              </p>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;
